import OmClient from '../../utilities/http_client';

export const updateDefaultPayment = async data => {
  await OmClient.getInstance().client.put(
    `/v1/purchasers/${data.purchaserId}/payment-method`,
    {
      paymentMethodId: data.paymentMethodId,
    }
  );
};

export const removeDefaultPayment = async data => {
  await OmClient.getInstance().client.patch(
    `/v1/purchasers/${data.purchaserId}/payment-method`,
    data
  );
};
